export const externalLinks = {
  privacyPolicy: 'https://quick.aero/privacy-policy/',
  contact: 'https://quick.aero/contact-us/',
  about: 'https://quick.aero/leading-technology/',
  helpDesk: 'https://quick.atlassian.net/servicedesk/customer/portal/3',
  conditionsOfCarriage: 'https://quick.aero/qonline-conditions-of-carriage/',
  trackSearch:
    'https://www.quickonline.com/cgi-bin/WebObjects/BOLSearch.woa/wa/',
  androidApp:
    'https://play.google.com/store/apps/details?id=com.quickintl.quickonlinemobile',
  iosApp: 'https://apps.apple.com/us/app/quickonline-mobile/id947806427',
  faaAirportStatus: 'https://nasstatus.faa.gov/',
  nationalWeatherService: 'https://www.weather.gov/',
  internationalWeatherService: 'https://weather.com/',
  usCustomsService: 'https://www.cbp.gov/',
  usPostalCodes: 'http://zip4.usps.com/zip4/citytown.jsp',
  usda: 'http://www.usda.gov/',
  usfda: 'http://www.fda.gov/',
};
